export const PAYMENT_NAMES = {
  loyalty: 'Puntos Gordos ',
  yappy: 'Yappy -',
  comercial: 'Cuenta a crédito -',
  claveweb: 'Tarjeta ',
  tarjetacreditoweb: 'Tarjeta ',
  puntos: 'Puntos Gordos -',
  regalo: 'Tarjeta de Regalo -',
  cmf: 'CMF ',
  ach: 'Transferencia ACH -',
}
